function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlueGreenBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.29166 132.29167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-164.70831)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fffff0",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    },
    id: "path907",
    d: "m 127.22029,132.89651 -23.49909,-2.78058 -8.230005,22.18571 -14.6502,-18.58253 -21.507162,9.86818 2.780577,-23.49909 -22.185713,-8.23001 18.582531,-14.650199 -9.868175,-21.507161 23.499088,2.780577 8.230007,-22.185713 14.6502,18.58253 21.507162,-9.868175 -2.78058,23.499089 22.18571,8.230006 -18.58253,14.650196 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    },
    id: "path911",
    d: "M 130.96207,154.54535 82.730492,141.46809 58.675158,185.27038 33.817298,141.91849 -14.165291,155.8817 -1.0880324,107.65012 -44.890326,83.594782 -1.5384302,58.736923 -15.501639,10.754334 32.729942,23.831592 56.785276,-19.970701 81.643136,23.381194 129.62572,9.4179858 116.54847,57.649566 l 43.80229,24.055335 -43.3519,24.857859 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    },
    id: "path913",
    d: "m 142.72193,259.84954 -39.06402,-6.58146 -15.585406,36.41988 -22.968637,-32.27622 -36.773297,14.7322 6.581459,-39.06402 -36.419885,-15.58541 32.276226,-22.96864 -14.732199,-36.7733 39.064018,6.58146 15.585409,-36.41988 22.968638,32.27622 36.773294,-14.73219 -6.58146,39.06401 36.41989,15.58541 -32.27623,22.96864 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.77897132,0.793078,-0.78932265,0.78267743,102.29541,-29.598598)",
    id: "g2594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6446",
    transform: "rotate(31.684343,121.31885,158.1054)",
    style: {
      fill: "#0000ff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6547",
    transform: "translate(98.340146,57.466144)",
    style: {
      stroke: "#000b66",
      strokeOpacity: 0.88888891
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6594",
    style: {
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45.378168,57.004478,113.09571)",
    id: "g2582",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2572",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2574",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5118718,-0.00997892)",
    id: "g6310",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2588",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2584",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2586",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2590",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2592",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45.251809,54.99012,114.61587)",
    id: "g6322",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6316",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6312",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6314",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6318",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6320",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6334",
    transform: "rotate(90.587588,55.539572,115.89906)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6328",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6324",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6326",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6330",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6332",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(134.45528,56.182183,115.71491)",
    id: "g6346",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6340",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6336",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6338",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6342",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6344",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6358",
    transform: "rotate(-174.43312,57.754095,114.31062)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6352",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6348",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6350",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6354",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6356",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-134.40332,56.645207,113.32915)",
    id: "g6370",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6364",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6360",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6362",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6366",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6368",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6394",
    transform: "rotate(-92.206207,54.908226,113.18007)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6388",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6384",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6386",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6390",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6392",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0000ff"
    },
    transform: "matrix(0.16951642,0.38198079,-0.38964837,0.16922539,183.44825,97.500967)",
    id: "g975"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000b66",
      strokeOpacity: 0.88888891
    },
    transform: "translate(102.92578,56.396282)",
    id: "g973"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g971"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g885",
    transform: "rotate(-45.378168,57.004478,113.09571)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect881",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect883",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g897",
    transform: "translate(1.5118718,-0.00997892)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g891"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect887",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect889",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect893",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect895",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g909",
    transform: "rotate(45.251809,54.99012,114.61587)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g903"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect899",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect901",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect905",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect907",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(90.587588,55.539572,115.89906)",
    id: "g921"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g915"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect911",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect913",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect917",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect919",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g933",
    transform: "rotate(134.45528,56.182183,115.71491)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g927"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect923",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect925",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect929",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect931",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(-174.43312,57.754095,114.31062)",
    id: "g945"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g939"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect935",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect937",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect941",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect943",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g957",
    transform: "rotate(-134.40332,56.645207,113.32915)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g951"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect947",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect949",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect953",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect955",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(-92.206207,54.908226,113.18007)",
    id: "g969"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g963"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect959",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect961",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect965",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect967",
    style: {
      opacity: 1,
      fill: "#3232cf",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path977",
    d: "m 199.652,156.57141 c -0.0644,4.9328 -0.23584,8.94759 -0.38102,8.92175 -0.14518,-0.0258 -1.98292,-1.73973 -4.08386,-3.80866 -2.10094,-2.06891 -3.87024,-3.7945 -3.93177,-3.83464 -0.1183,-0.0772 -5.02368,4.75323 -4.96738,4.89142 0.0181,0.0444 0.78498,0.79949 1.7042,1.67802 7.75687,7.41342 18.09143,17.84316 17.96468,18.13014 -0.22623,0.51223 -13.286,13.62629 -13.27415,13.32933 0.005,-0.13703 0.22446,-2.56951 0.48665,-5.40551 l 0.47672,-5.15637 -3.45498,-0.29528 -3.45499,-0.29527 -1.00899,10.54095 c -0.55495,5.79753 -1.179,12.07972 -1.38678,13.96041 l -0.37778,3.41946 -6.98103,-0.70226 c -3.83957,-0.38624 -8.06655,-0.83741 -9.39329,-1.0026 l -2.41227,-0.30035 4.89974,-4.79616 c 2.69485,-2.6379 4.94815,-4.90748 5.00733,-5.04351 0.13419,-0.30848 -4.38523,-4.95604 -4.70053,-4.8338 -0.12646,0.049 -4.42078,4.19799 -9.54292,9.21994 -5.12215,5.02193 -9.56562,9.36286 -9.87437,9.6465 -0.5296,0.48653 -0.91811,0.14953 -6.86579,-5.95568 -3.46744,-3.55926 -6.42952,-6.60477 -6.58241,-6.76778 -0.15288,-0.16302 1.99862,-0.37987 4.78112,-0.48187 7.16772,-0.26278 6.48278,0.10752 6.364,-3.44066 -0.0559,-1.66949 -0.16737,-3.19684 -0.24773,-3.39411 -0.0804,-0.19726 -5.11132,-0.16542 -11.17989,0.0708 -6.06856,0.23619 -12.32648,0.46916 -13.90649,0.51772 l -2.87273,0.0883 -0.29229,-8.82017 c -0.16076,-4.85109 -0.30366,-9.00894 -0.31757,-9.23965 -0.0139,-0.23072 1.97319,1.55256 4.41576,3.96284 2.44257,2.41029 4.56327,4.44624 4.71268,4.52436 0.21537,0.1126 4.65442,-4.05132 4.88564,-4.58283 0.0324,-0.0744 -4.38709,-4.52697 -9.821,-9.89462 -5.4339,-5.36765 -9.82151,-9.88788 -9.75022,-10.04496 0.18974,-0.41811 13.33215,-13.57903 13.49179,-13.51081 0.0744,0.0318 0.1412,2.48727 0.14845,5.4566 0.007,2.96934 0.14323,5.53748 0.30216,5.707 0.30105,0.32109 6.41041,0.36312 6.54878,0.0451 0.0593,-0.1364 0.15875,-23.85691 0.11432,-27.27544 -0.007,-0.50227 1.16917,-0.57678 8.44115,-0.53497 4.6468,0.0267 8.75819,0.059 9.1364,0.0717 0.53345,0.0179 -0.28151,0.9795 -3.63356,4.28716 -2.37668,2.34521 -4.39104,4.40689 -4.47634,4.58151 -0.17019,0.34833 4.30248,5.07182 4.66823,4.93002 0.12454,-0.0483 4.57026,-4.40126 9.87938,-9.67328 5.30912,-5.27202 9.78961,-9.59258 9.95663,-9.60122 0.3459,-0.0179 14.36135,14.19137 14.25008,14.44716 -0.0399,0.0917 -2.54268,0.1533 -5.56174,0.13682 -3.01906,-0.0165 -5.55991,0.13262 -5.64634,0.33129 -0.28297,0.65048 -0.1816,6.35024 0.1151,6.47172 0.15915,0.0652 6.46718,0.17188 14.01783,0.23714 l 13.72846,0.11865 z",
    style: {
      fill: "#74ff5e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.33112296px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path979",
    d: "m 166.94685,224.29421 c -5.27012,1.27985 -9.58283,2.30392 -9.5838,2.27571 -9.7e-4,-0.0282 1.4653,-1.98299 3.25837,-4.34396 1.79307,-2.36097 3.25991,-4.32565 3.25964,-4.36594 -5.1e-4,-0.0769 -5.17941,-4.03689 -5.27859,-4.03623 -0.0315,2.1e-4 -3.86838,5.01238 -8.52649,11.13817 -4.65812,6.12579 -8.48186,11.1358 -8.49721,11.13336 -0.0511,-0.008 -15.30662,-11.733 -15.30221,-11.76079 0.002,-0.015 3.16415,-0.73889 7.02615,-1.60858 3.86199,-0.86969 7.01846,-1.59988 7.01437,-1.62265 -0.004,-0.0228 -0.33624,-1.48737 -0.73812,-3.25467 -0.59431,-2.61356 -0.77747,-3.21159 -0.98138,-3.20423 -0.13789,0.005 -4.5391,0.98105 -9.78048,2.16905 -5.24138,1.188 -9.58326,2.13662 -9.64862,2.10805 -0.0654,-0.0286 -0.16209,-0.008 -0.21494,0.0454 -0.0529,0.0536 -1.76352,0.47424 -3.80149,0.93486 -3.52961,0.79776 -3.70883,0.82154 -3.77803,0.50138 -0.04,-0.18485 -0.96613,-4.37422 -2.05814,-9.30969 -1.09202,-4.93548 -1.91693,-8.97073 -1.83313,-8.96721 0.0838,0.004 2.34114,1.25132 5.0163,2.77291 3.65947,2.08144 4.90041,2.7297 5.0112,2.61783 0.29276,-0.29553 3.19044,-5.55437 3.12814,-5.67693 -0.0351,-0.0692 -5.41008,-3.14686 -11.94429,-6.83937 -6.53422,-3.69251 -11.975951,-6.79019 -12.09273,-6.88374 -0.191236,-0.15319 0.245949,-0.97411 4.39967,-8.26145 2.5366,-4.45025 4.6393,-8.09417 4.67266,-8.09761 0.0333,-0.003 0.73932,2.7829 1.56881,6.19186 0.82948,3.40895 1.54814,6.26488 1.59701,6.3465 0.0489,0.0816 1.52526,-0.19816 3.28086,-0.62172 2.40683,-0.58069 3.18971,-0.82537 3.18264,-0.99471 -0.005,-0.12352 -1.48033,-6.24185 -3.27817,-13.59628 -1.79784,-7.35443 -3.2701,-13.3957 -3.27169,-13.42504 -0.002,-0.0293 4.35565,-1.09425 9.68278,-2.36648 5.32712,-1.27222 9.68591,-2.27739 9.68619,-2.2337 2.9e-4,0.0437 -1.35381,2.27362 -3.00911,4.9554 -1.6553,2.68177 -3.0093,4.92717 -3.00889,4.98978 6.1e-4,0.0916 5.43709,3.54579 5.60479,3.56116 0.0261,0.002 3.35816,-5.35961 7.40465,-11.91554 4.0465,-6.55594 7.37443,-11.91799 7.39542,-11.91566 0.10371,0.0115 15.69089,9.77493 15.69495,9.83095 0.003,0.0358 -2.83022,0.72269 -6.29516,1.52648 -4.92815,1.14322 -6.2867,1.50994 -6.23934,1.6842 0.0333,0.12252 0.37871,1.59729 0.76756,3.27726 0.38885,1.67997 0.76596,3.04967 0.83802,3.04377 0.0721,-0.006 6.22755,-1.42803 13.67889,-3.1603 l 13.54787,-3.14957 0.10038,0.44772 c 0.0552,0.24625 1.10896,4.88312 2.34167,10.30416 1.23272,5.42104 2.18476,9.85247 2.11565,9.84763 -0.0691,-0.005 -1.94254,-1.16194 -4.16317,-2.57134 -5.71264,-3.62573 -5.66323,-3.59609 -5.78939,-3.47336 -0.0628,0.061 -0.88193,1.31566 -1.8203,2.78793 -1.14234,1.79229 -1.6643,2.71838 -1.57952,2.80249 0.0696,0.0691 5.3724,3.43922 11.78394,7.48915 6.5457,4.13469 11.65479,7.43629 11.65154,7.52947 -0.006,0.17417 -9.77323,15.52892 -9.87839,15.52962 -0.0334,2e-4 -0.6934,-2.56289 -1.46677,-5.69579 -0.77337,-3.13291 -1.42744,-5.69222 -1.45348,-5.68737 -0.43825,0.0816 -6.13597,1.53348 -6.28452,1.60139 -0.15685,0.0717 0.32123,2.23329 1.96265,8.8739 1.19351,4.82851 2.14579,8.87513 2.11618,8.99249 -0.0296,0.11737 0.008,0.27439 0.0835,0.34894 0.10789,0.10648 2.02598,7.57346 2.25434,8.77597 0.0466,0.24532 -1.0718,0.55104 -9.52926,2.60494 z m -4.41284,-26.62651 -1.07376,-2.54292 2.71971,-6.62659 c 1.49584,-3.64463 2.72063,-6.69292 2.72174,-6.77398 0.001,-0.0811 -1.02521,-0.54263 -2.28071,-1.02572 -1.25551,-0.48308 -2.3483,-0.94304 -2.42844,-1.02213 -0.0801,-0.0791 -1.30803,-2.80058 -2.72865,-6.04775 -1.42062,-3.24719 -2.63489,-5.96708 -2.69836,-6.04421 -0.07,-0.0851 -1.14144,0.29777 -2.72525,0.9739 l -2.60984,1.11414 -6.52294,-2.47169 c -3.58763,-1.35943 -6.58133,-2.47131 -6.65268,-2.47083 -0.0713,4.7e-4 -0.51504,0.98386 -0.98597,2.1853 -0.47093,1.20145 -0.91488,2.244 -0.98657,2.31678 -0.0717,0.0728 -2.89415,1.44427 -6.27214,3.04775 -3.60545,1.71145 -6.13964,2.98735 -6.13656,3.08961 0.003,0.0958 0.55986,1.30201 1.23771,2.68046 0.67785,1.37844 1.22894,2.52577 1.22463,2.5496 -0.004,0.0238 -1.16127,2.80815 -2.57103,6.18736 -1.40975,3.37921 -2.52289,6.18378 -2.47364,6.23239 0.0493,0.0486 1.05163,0.46451 2.22752,0.92422 1.17588,0.45971 2.17174,0.86918 2.21303,0.90992 0.0413,0.0408 0.98255,2.87388 2.0917,6.29586 1.10915,3.42198 2.07601,6.22164 2.14858,6.22147 0.0726,-1.6e-4 1.28839,-0.36772 2.70184,-0.81679 l 2.5699,-0.81649 6.79975,2.54426 c 3.73986,1.39935 6.84991,2.56477 6.91122,2.58982 0.0613,0.025 0.57942,-1.15857 1.15134,-2.63028 l 1.03987,-2.67583 1.12492,-0.47699 c 0.61871,-0.26234 3.39174,-1.41532 6.1623,-2.56216 2.77056,-1.14685 5.06824,-2.13701 5.10595,-2.20036 0.0377,-0.0633 -0.41461,-1.25951 -1.00517,-2.65812 z",
    style: {
      fill: "#57994e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.13951428px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlueGreenBlack);
export default __webpack_public_path__ + "static/media/logo-blue-green-black.e3165c58b97c395643f378b52e690fb4.svg";
export { ForwardRef as ReactComponent };